module.exports = __webpack_public_path__ + "static/media/deski.24aecf73.svg";